import SportsBasketballIcon from '@mui/icons-material/SportsBasketball'
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball'
import SportsFootballIcon from '@mui/icons-material/SportsFootball'
import SportsTennisIcon from '@mui/icons-material/SportsTennis'
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer'
import SportsMmaIcon from '@mui/icons-material/SportsMma'
import SportsKabaddiIcon from '@mui/icons-material/SportsKabaddi'
import SportsCricketIcon from '@mui/icons-material/SportsCricket'
import SportsVolleyballIcon from '@mui/icons-material/SportsVolleyball'
import SportsRugbyIcon from '@mui/icons-material/SportsRugby'
import SportsGolfIcon from '@mui/icons-material/SportsGolf'
import SportsHockeyIcon from '@mui/icons-material/SportsHockey'
import SportsHandballIcon from '@mui/icons-material/SportsHandball'
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports'
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike'
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun'
import PoolIcon from '@mui/icons-material/Pool'
import DownhillSkiingIcon from '@mui/icons-material/DownhillSkiing'
import RadarIcon from '@mui/icons-material/Radar'
import AdjustIcon from '@mui/icons-material/Adjust'
import HowToVoteIcon from '@mui/icons-material/HowToVote'
import SportsIcon from '@mui/icons-material/Sports'

/**
 * The feed names sports its own way — underscores, odd capitals, and new ones appearing whenever the
 * book opens a market. Matching on a normalised key rather than the literal string means Rugby_league
 * and "rugby league" land in the same place, and the fallback means a sport nobody anticipated still
 * gets a mark rather than leaving a hole where every other row has one.
 */
const ICONS = {
  soccer: <SportsSoccerIcon />,
  football: <SportsFootballIcon />,
  americanfootball: <SportsFootballIcon />,
  basketball: <SportsBasketballIcon />,
  baseball: <SportsBaseballIcon />,
  tennis: <SportsTennisIcon />,
  tabletennis: <SportsTennisIcon />,
  badminton: <SportsTennisIcon />,
  cricket: <SportsCricketIcon />,
  volleyball: <SportsVolleyballIcon />,
  beachvolleyball: <SportsVolleyballIcon />,
  handball: <SportsHandballIcon />,
  boxing: <SportsMmaIcon />,
  mma: <SportsKabaddiIcon />,
  rugby: <SportsRugbyIcon />,
  rugbyleague: <SportsRugbyIcon />,
  rugbyunion: <SportsRugbyIcon />,
  aussierules: <SportsRugbyIcon />,
  golf: <SportsGolfIcon />,
  hockey: <SportsHockeyIcon />,
  icehockey: <SportsHockeyIcon />,
  darts: <RadarIcon />,
  snooker: <AdjustIcon />,
  pool: <AdjustIcon />,
  motorsport: <SportsMotorsportsIcon />,
  motorsports: <SportsMotorsportsIcon />,
  formula1: <SportsMotorsportsIcon />,
  cycling: <DirectionsBikeIcon />,
  athletics: <DirectionsRunIcon />,
  swimming: <PoolIcon />,
  wintersports: <DownhillSkiingIcon />,
  skiing: <DownhillSkiingIcon />,
  esports: <SportsEsportsIcon />,
  politics: <HowToVoteIcon />,
  entertainment: <HowToVoteIcon />
}

const key = (sportName) => String(sportName || '').toLowerCase().replace(/[^a-z0-9]/g, '')

function sportIcon(sportName) {
  // a whistle for anything unlisted: a generic mark beats a gap in an otherwise even column
  return ICONS[key(sportName)] || <SportsIcon />
}

export default sportIcon
